import vWebp from '~/directives/v-webp'
import vWebpSize from '~/directives/v-webpsize'
import placeholderError from '~/assets/images/placeholder-error.webp'

// 扩展 HTMLImageElement 类型
declare global {
  interface HTMLImageElement {
    _observer?: IntersectionObserver
  }
}

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('webp', vWebp)
  nuxtApp.vueApp.directive('webpsize', vWebpSize)

  // 定义 v-lazy 指令
  nuxtApp.vueApp.directive('lazy', {
    mounted(el: HTMLImageElement, binding: any) {
      // 添加默认的 loading 状态
      el.src =
        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjdmN2Y3Ii8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkxvYWRpbmcuLi48L3RleHQ+Cjwvc3ZnPg=='
      el.classList.add('lazy-loading')

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target as HTMLImageElement
              const originalSrc = binding.value

              // 直接设置图片src，避免重复加载
              img.src = originalSrc
              img.classList.remove('lazy-loading')
              img.classList.add('lazy-loaded')

              // 设置错误处理
              img.onerror = () => {
                img.src = placeholderError // 错误占位图
                img.classList.remove('lazy-loading')
                img.classList.add('lazy-error')
                img.onerror = null // 防止无限循环
              }

              observer.unobserve(img)
            }
          })
        },
        {
          rootMargin: '50px' // 提前50px开始加载
        }
      )

      observer.observe(el)

      // 保存 observer 到元素上，便于卸载时清理
      el._observer = observer
    },

    beforeUnmount(el: HTMLImageElement) {
      // 清理 observer
      if (el._observer) {
        el._observer.disconnect()
        delete el._observer
      }
    }
  })
})
